const DB_NAME = 'PhrasesDB';
const DB_VERSION = 1;
const STORE_NAME = 'phrases';
const KEY_PATH = 'id';

type TranslatedPhrases = Record<string, string>;

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE_NAME)) {
        request.result.createObjectStore(STORE_NAME, {
          keyPath: KEY_PATH,
          autoIncrement: true
        });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function checkDB(
  phrases: string[],
  targetLang: string
): Promise<TranslatedPhrases> {
  const db = await openDB();
  const transaction = db.transaction(STORE_NAME, 'readonly');
  const store = transaction.objectStore(STORE_NAME);
  const request = store.getAll();

  return new Promise((resolve) => {
    request.onsuccess = () => {
      const result = request.result;
      const found: TranslatedPhrases = {};

      for (const phrase of phrases) {
        for (const entry of result) {
          const targetVal = entry[targetLang];
          if (typeof targetVal !== 'string' || !targetVal.length) {
            continue;
          }

          if (Object.values(entry).includes(phrase)) {
            found[phrase] = targetVal;
            break;
          }
        }
      }

      resolve(found);
    };
  });
}

export async function addDBPhrases(
  entries: Record<string, string>,
  sourceLang: string,
  targetLang: string
) {
  const db = await openDB();
  const transaction = db.transaction(STORE_NAME, 'readwrite');
  const store = transaction.objectStore(STORE_NAME);

  const request = store.getAll();

  request.onsuccess = () => {
    const result = request.result;

    Object.entries(entries).forEach(([phrase, translation]) => {
      const existingEntry = result.find((entry) =>
        Object.values(entry).includes(phrase)
      );

      if (existingEntry) {
        store.put({
          ...existingEntry,
          [targetLang]: translation
        });
      } else {
        store.add({
          [sourceLang]: phrase,
          [targetLang]: translation
        });
      }
    });
  };
}
